import { LightningElement, api, wire } from "lwc";
import { AnimationAdapter } from "common/animationAdapter";
import { ResizeObserverAdapter } from "common/resizeObserverAdapter";
import { assignedElements, children } from "common/slot";

let uid = 0;
class stencil extends LightningElement {
  @api variant = "brick";
  @wire(AnimationAdapter)
  animation = null;
  _id = uid++;

  // HACK: Safari doesn't like when SVG uses a non-unique id even inside a ShadowRoot
  get gradientId() {
    return `tds-stencil-gradient-${this._id}`;
  }

  // HACK: Safari doesn't like when SVG uses a non-unique id even inside a ShadowRoot
  get shapeClipId() {
    return `tds-stencil-clip-${this._id}`;
  }
  get shapeClipPath() {
    return `url('#${this.shapeClipId}')`;
  }
  get shapeStyle() {
    return `fill: url('#${this.gradientId}');`;
  }
  get stencilDetails() {
    return this.variant == "tile-details";
  }
  @wire(ResizeObserverAdapter, {
    template: "$template",
  })
  onResize() {
    this.setInnerHTML();
  }
  renderedCallback() {
    let $clipPath = this.template.querySelector("[data-id=clip]");
    let $gradient = this.template.querySelector("[data-id=gradient]");
    $clipPath.setAttribute("id", this.shapeClipId);
    $gradient.setAttribute("id", this.gradientId);
    this.setInnerHTML();
  }
  setInnerHTML() {
    let $slot = this.template.querySelector("slot");
    let $clipPath = this.template.querySelector("[data-id=clip]");
    if (!$clipPath) return;
    let $stencils = assignedElements($slot);
    if (!$stencils.length) $stencils = children($slot);
    if ($stencils.length === 0) return;
    if ($stencils.length > 1)
      throw new Error("`<tds-stencil> should only have 1 direct child");
    $stencils = flatten($stencils[0]);
    let $mask = $stencils.find((e) => e.hasAttribute("data-stencil"));
    let $maskItems = $stencils.filter((e) =>
      e.hasAttribute("data-stencil-item")
    );
    if (!$mask)
      throw new Error(
        '<tds-stencil> unable to find an element with attribite "data-stencil"'
      );
    let maskRect = $mask.getBoundingClientRect();
    let maskItemRects = $maskItems.map((element) => {
      let itemRect = element.getBoundingClientRect();
      let style = getComputedStyle(element);
      return {
        x: itemRect.x - maskRect.x,
        y: itemRect.y - maskRect.y,
        width: itemRect.width,
        height: itemRect.height,
        radius: {
          tl: parseInt(style.borderTopLeftRadius || "0", 10),
          tr: parseInt(style.borderTopRightRadius || "0", 10),
          br: parseInt(style.borderBottomRightRadius || "0", 10),
          bl: parseInt(style.borderBottomLeftRadius || "0", 10),
        },
      };
    });
    $clipPath.innerHTML = maskItemRects
      .map(({ x, y, width, height, radius }) => {
        let isCircle =
          width === height &&
          radius.tl === width / 2 &&
          radius.tr === width / 2 &&
          radius.br === width / 2 &&
          radius.bl === width / 2;
        if (isCircle) {
          let cx = x + width / 2;
          let cy = y + height / 2;
          let r = width / 2;
          return `<circle cx="${cx}" cy="${cy}" r="${r}" />`;
        }
        return `<path d="
          M${x + radius.tr},${y}
          h${width - radius.tl - radius.tr}
          q${radius.tr},0 ${radius.tr},${radius.tr}
          v${height - radius.tr - radius.br}
          q0,${radius.br} ${-radius.br},${radius.br}
          h-${Math.abs(width - radius.tr - radius.tl)}
          q-${radius.bl},0 -${radius.bl},-${radius.bl}
          v-${Math.abs(height - radius.tl - radius.bl)}
          q 0,-${radius.tl} ${radius.tl},-${radius.tl}
          z" />`;
      })
      .join("\n");
  }
}
function flatten(element) {
  return [element].concat(
    Array.from(element.children).flatMap((e) => flatten(e))
  );
}

export default stencil;
